import { isString } from "lodash/fp";
import { z } from "zod";

import { isValidDate } from "@/utils";
import { getLocalTimeZone, ZonedDateTime } from "@internationalized/date";
import { DateValue } from "@kirvanobr/calendar";

export const DateSchema = z.coerce
  .string()
  .or(z.date())
  .refine(isValidDate, { message: "Data inválida" })
  .transform(value => {
    if (isString(value)) {
      return value.includes("/") ? new Date(value.split("/").reverse().join("-")) : new Date(value);
    }

    return new Date(value);
  });

export const DateStringSchema = z
  .string()
  .datetime({ offset: true })
  .or(
    z.object({
      calendar: z.object({ identifier: z.string().optional() }),
      day: z.number(),
      era: z.string(),
      month: z.number(),
      year: z.number(),
    })
  )
  .transform(value => {
    if (!isString(value)) {
      const dateValue = value as DateValue;
      const dateInUTC = new ZonedDateTime(
        dateValue.year,
        dateValue.month,
        dateValue.day,
        getLocalTimeZone(),
        0,
        0,
        0
      ).toAbsoluteString();
      return dateInUTC;
    }
    return value;
  });
